import { Inject, DOCUMENT } from '@angular/core';

import { PAGE_SCROLL_STRATEGY } from './page-scroll-strategy';
import type { PageScrollStrategy } from './page-scroll-strategy';

export class PageScrollToTopStrategy implements PageScrollStrategy {

  constructor(@Inject(DOCUMENT) private document: Document) {
  }

  /** Attaches this position strategy to an overlay. */
  scroll(): void {
    this.document.body.scrollTop = this.document.documentElement.scrollTop = 0;
  }
}

export const PAGE_SCROLL_TOP_STRATEGY_PROVIDER = {
  provide: PAGE_SCROLL_STRATEGY,
  useClass: PageScrollToTopStrategy
};
